export enum DepositPromotionQueryKeys {
	GetDepositPromotionList = 'deposit.getDepositPromotionList',
	GetDepositPromotionById = 'deposit.getDepositPromotionById',
	GetDepositPromotionNamesForSelector = 'deposit.getDepositPromotionNamesForSelector',
	GetDepositPromotionNamesForSelectorChannel = 'deposit.getDepositPromotionNamesForSelectorChannel',
	GetDepositPromotionNamesForSelectorCoupon = 'deposit.getDepositPromotionNamesForSelectorCoupon',
	GetDepositPromotionNamesForBrokeNotification = 'deposit.getDepositPromotionNamesForBrokeNotification',
	GetPresetId = 'deposit.getPresetId',
	GetDepositPromotionPresets = 'deposit.getDepositPromotionPresets',
}

export enum DepositPromotionMutationKeys {
	CreateDepositPromotion = 'deposit.createDepositPromotion',
	UpdateDepositPromotion = 'deposit.updateDepositPromotion',
	DeleteDepositPromotion = 'deposit.deleteDepositPromotion',
	ApplyDepositPromotionPreset = 'deposit.applyDepositPromotionPreset',
}

export enum CommissionCashbackQueryKeys {
	GetCommissionCashbackList = 'commissionCashback.getCommissionCashbackList',
	GetCommissionCashbackById = 'commissionCashback.getCommissionCashbackById',
	GetCommissionName = 'commissionCashback.getCommissionName',
}

export enum CommissionCashbackMutationKeys {
	CreateCommissionCashback = 'commissionCashback.createCommissionCashback',
	UpdateCommissionCashback = 'commissionCashback.updateCommissionCashback',
	DeleteCommissionCashback = 'commissionCashback.deleteCommissionCashback',
}

export enum ReturnLossQueryKeys {
	GetReturnLossList = 'returnLoss.getReturnLossList',
	GetReturnLossById = 'returnLoss.getReturnLossById',
	GetReturnLossName = 'returnLoss.getReturnLossName',
}

export enum ReturnLossMutationKeys {
	CreateReturnLoss = 'returnLoss.createReturnLoss',
	UpdateReturnLoss = 'returnLoss.updateReturnLoss',
	DeleteReturnLoss = 'returnLoss.deleteReturnLoss',
}

export enum DailyCheckInQueryKeys {
	GetDailyCheckIn = 'dailyCheckIn.getDailyCheckIn',
	GetDailyCheckInById = 'dailyCheckIn.getDailyCheckInById',
	GetDailyCheckInName = 'dailyCheckIn.getDailyCheckInName',
}

export enum DailyCheckInMutationKeys {
	UpdateDailyCheckIn = 'dailyCheckIn.updateDailyCheckIn',
	CreateDailyCheckIn = 'dailyCheckIn.createDailyCheckIn',
	DeleteDailyCheckIn = 'dailyCheckIn.deleteDailyCheckIn',
}

export enum LuckyWheelQueryKeys {
	GetLuckyWheel = 'luckyWheel.getLuckyWheel',
	GetLuckyWheelImagePresets = 'luckyWheel.getImagePresets',
}

export enum LuckyWheelMutationKeys {
	UpdateLuckyWheel = 'luckyWheel.updateLuckyWheel',
	SpinLuckyWheel = 'luckyWheel.spinLuckyWheel',
}

export enum InviteFriendQueryKeys {
	GetInviteFriend = 'inviteFriend.getInviteFriend',
}

export enum InviteFriendMutationKeys {
	UpdateInviteFriend = 'inviteFriend.updateInviteFriend',
}

export enum DailyPlayerReturnLossQueryKeys {
	GetDailyPlayerReturnLossList = 'dailyPlayerReturnLoss.getDailyPlayerReturnLossList',
}

export enum ReturnLossHistoryQueryKeys {
	GetReturnLossHistoryList = 'returnLossHistory.getReturnLossHistoryList',
}

export enum InviteFriendCommissionHistoryQueryKeys {
	GetInviteFriendCommissionHistoryList = 'inviteFriendCommissionHistory.getInviteFriendCommissionHistoryList',
}
